<template>
  <div class="candidate-info">
    <div class="candidate-info-icon">
      <img src="@/assets/icons/genicon-icons8-birthday.svg" alt="birthday" />
    </div>
    <span
      :class="{ truncate: shortVersion }"
      v-html="
        $t('views.single.candidate.birthyear', {
          year: candidate.birthYear || '-',
          age: !isNullOrWhitespace(candidate.birthYear)
            ? new Date().getFullYear() - parseInt(candidate.birthYear)
            : '-'
        })
      "
    ></span>
  </div>
</template>

<script>
import constants from "@/constants";

export default {
  name: "Birthday",
  props: {
    candidate: {
      type: Object,
      required: true
    },
    shortVersion: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      referenceKey: constants.CANDIDATE_NOTE_BIRTHDAY,
      type: constants.CANDIDATE_NOTE_PROFILE
    };
  },
  methods: {
    isNullOrWhitespace(value) {
      return !(value != null && value.toString().trim() !== "");
    }
  }
};
</script>
